module.exports = __webpack_public_path__ + "static/media/purple-button.88a3e415.png";